import React from 'react';
import NowLoadingMessage from '@src/components/NowLoadingMessage/NowLoadingMessage';

const ProductTechProcessesField = React.lazy(() => import('@views/products/fields/ProductTechProcessesField'));

export default function ProductTechProcessesLazyField() {
    return <React.Suspense fallback={<NowLoadingMessage/>}>
        <ProductTechProcessesField/>
    </React.Suspense>;
}
